// extracted by mini-css-extract-plugin
export default {"detailscont":"Wrapper_detailscont__z1R3q","grid":"Wrapper_grid__Dq58l","subCont":"Wrapper_subCont__lQ6HK"};